import React, { useEffect, useState } from "react";
import { MODULE_API } from "../../apis";
import * as Styles from "./Styles/InsuranceSubformStyle";
import { useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";
import { FormCreator } from "./components/FormCreator";
import "./Styles/InsuranceAllocationStyle.css";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import { InsuranceFormSkeleton } from "../InsuranceNew/InsuraceDashboardComponents/InsuranceFormSkeleton";
const InsuranceAllocationSubform = () => {
  const history = useHistory();
  const { module } = useParams();
  const { id } = useParams();
  const { view } = useParams();
  const [moduleName, setModuleName] = useState(null);
  const [moduleId, setModuleId] = useState(null);
  const [loading, setIsLoading] = useState(false);
  const [fields, setFields] = useState({});
  const [tabs, setTabs] = useState([]);
  const [tabsControl, setTabsControl] = useState({});
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [activeTabName, setActiveTabName] = useState("");
  const [submitBody, setSubmitBody] = useState({});
  const [fieldsData, setFieldsData] = useState({});
  const [attributes, setAttributes] = useState({});
  const [submitting, setSubmitting] = useState(false);

  // Fetch insurance fields
  const getInsuranceFields = async (Name) => {
    setIsLoading(true);
    try {
      const res = await MODULE_API.assetFiledDetails(Name);
      if (res && res.attributes) {
        const allAttributes = [...res.attributes];
        const sortedAttributes =
          allAttributes &&
          allAttributes.sort(
            (a, b) => a.groupPriorityValue - b.groupPriorityValue
          );
        setAttributes(sortedAttributes && sortedAttributes);
        sortedAttributes &&
          sortedAttributes.map((attribute) => {
            setFields((prevValue) => {
              return {
                ...prevValue,
                [attribute["groupName"]]: {
                  ...(prevValue[attribute["groupName"]] || {}),
                  [attribute["id"]]: attribute,
                },
              };
            });
          });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const desiredOrder = [
    "Policy Name (Person(s)/Property Insured)",
    "Owner",
    "Policy Start Date",
    "Policy End Date",
    "Insurance Company",
    "Policy Number",
    "Upload Document"
  ];
  
  const getInsuranceFieldsNew = async (Name) => {
    setIsLoading(true);
    try {
      const res = await MODULE_API.assetFiledDetails(Name);
      if (res && res.attributes) {
        const allAttributes = [...res.attributes];
  
        // Sort all by group priority
        const sortedByGroupPriority = allAttributes.sort(
          (a, b) => a.groupPriorityValue - b.groupPriorityValue
        );
  
        // Separate "PRODUCT INFORMATION" group
        const productInfoAttrs = sortedByGroupPriority.filter(
          (attr) => attr.groupName === "PRODUCT INFORMATION"
        );
        const otherAttrs = sortedByGroupPriority.filter(
          (attr) => attr.groupName !== "PRODUCT INFORMATION"
        );
  
        // Custom order for PRODUCT INFORMATION group
        const sortedProductInfoAttrs = [
          ...desiredOrder
            .map((name) => productInfoAttrs.find((attr) => attr.name === name))
            .filter(Boolean), // Remove undefined
          ...productInfoAttrs.filter((attr) => !desiredOrder.includes(attr.name))
        ];
  
        // Combine back full list
        const finalSortedAttributes = [...sortedProductInfoAttrs, ...otherAttrs];
  
        // Create new structured field state
        const groupedFields = {};
  
        for (const attribute of finalSortedAttributes) {
          const group = attribute.groupName;
          if (!groupedFields[group]) {
            groupedFields[group] = {};
          }
          groupedFields[group][["PRODUCT INFORMATION", "MEDICARE INSURANCE INFORMATION"].includes(group) ? attribute.priority : attribute.id] = attribute;
        }
  
        // Set both states at once to preserve order
        setAttributes(finalSortedAttributes);
        setFields(groupedFields);
      }
    } finally {
      setIsLoading(false);
    }
  };

  
  // Fetch insurance fields data
  const getInsuranceFieldsData = async (id) => {
    setIsLoading(true);
    try {
      const res = await MODULE_API.fetchSingleGoalDetails(id);
      if (res && res.data) {
        setFieldsData(res.data);
      }
    } finally {
      setIsLoading(false);
    }
  };
  // Create dynamic tabs from attributes
  const createDynamicTabs = (fields) => {
    const newTabs = Object.keys(fields).map((key, index) => ({
      name: key.toUpperCase(),
      enabled: true,
      priority: index + 1,
    }));
    setTabs(newTabs);
  };
  // Handle previous button click
  const handlePreviousFormButton = () => {
    let temp = Object.values(tabsControl);
    let a = temp.indexOf(activeTabName);
    let b = Object.keys(tabsControl)[a - 1];
    setActiveTabName(tabsControl[b]);
  };

  // Handle next button click
  const handleNextFormButton = () => {
    let temp = Object.values(tabsControl);
    let a = temp.indexOf(activeTabName);
    let b = Object.keys(tabsControl)[a + 1];
    setActiveTabName(tabsControl[b]);
  };
  // Handle submit
  const handleSubmit = async () => {
    if (submitting) return; // Prevent multiple clicks
    try {
      setSubmitting(true);  // Mark as submitting
      setIsLoading(true);
      console.log("submitBody", submitBody);
        if (moduleName && !moduleId) {
          const moduleNew = await MODULE_API.addAsset(moduleName, {
            clientModules: [{ ...submitBody, }],
          });
        } else if (moduleId && moduleName && !view) {
          await MODULE_API.updateClientModule(moduleId, { ...submitBody,});
        }
      setIsLoading(false);
      history.push("/organizer/insurance");
    } catch (error) {
      swal({
        title: "Error",
        text: "Error while Saving Module",
        icon: "error",
        buttons: true,
        dangerMode: true,
      });
    } finally {
      setIsLoading(false);
      setSubmitting(false); // Allow re-submission later
    }
  };
  // Set current tab
  const currentTab = (tab) => {
    let tabs2 = tabs && tabs.map((tab) => tab.name);
    let cond = tabs2.includes(tab);
    if (cond) {
      let ind = tabs2.indexOf(tab);
      setActiveTabIndex(ind);
      setActiveTabName(tab);
    }
  };
  // Update tabs when fields change
  useEffect(() => {
    setTabs(Object.keys(fields));
    console.log("fields", fields);
    createDynamicTabs(fields);
  }, [fields]);

  // Set active tab on initial load
  useEffect(() => {
    if (tabs.length > 0) {
      currentTab(tabs[0].name);
    }
  }, [tabs]);
  useEffect(() => {
    const tabNamesArray = tabs && tabs.map((tab) => tab.name);
    let temp = tabNamesArray.indexOf(activeTabName);
    if (temp !== -1) {
      setActiveTabIndex(temp);
    }
  }, [activeTabName]);
  useEffect(() => {
    console.log("module", module, id);
    setAttributes({});
    setFields({});
    setFieldsData({});
    fetchAll();
  }, [module, id]);

  const fetchAll = async () => {
    if (module && ["Automobile V2", "Medicare V2"].includes(module)) {
      await getInsuranceFieldsNew(module);
      setModuleName(module);
    }else{
      await getInsuranceFields(module);
      setModuleName(module);
    }
    if (id) {
      await getInsuranceFieldsData(id);
      setModuleId(id);
    }
  };

  // Create tabs control for navigation
  useEffect(() => {
    const tabsControl = {};
    tabs.forEach((tab, index) => {
      tabsControl[index + 1] = tab.name;
    });
    setTabsControl(tabsControl);
  }, [tabs]);
  const allTabs =
    tabs &&
    tabs.reduce((acc, tab, index) => {
      acc[tab.name] = {
        name: tab.name,
        enabled: tab.enabled,
        priority: tab.priority,
      };
      return acc;
    }, {});
  console.log("allTabs", tabs);
  const tabNamesArray = tabs && tabs.map((tab) => tab.name);
  return (
    attributes && attributes.length > 0 ?
    <div style={{ position: "relative" }}>
      <hr />
      <TabNavigationComponent
        tabs={tabNamesArray}
        activeTabIndex={activeTabIndex}
        setActiveTabIndex={setActiveTabIndex}
        activeTabName={activeTabName}
        setActiveTabName={setActiveTabName}
        currentTab={currentTab}
        AllTabs={allTabs}
      />
      <hr />
      <form>
        {tabNamesArray.length > 0 && (
          <FormCreator
            data={fields[tabNamesArray[activeTabIndex]]}
            attributes={attributes && attributes}
            values={fieldsData}
            title={tabs[activeTabIndex]}
            setSubmitBody={setSubmitBody}
            activeTabName={activeTabName}
          />
        )}
      </form>
      {tabs.length > 0 && (
        <div className="insuranace-form-buttons-conatiner">
          <button
            onClick={()=>{
              if(activeTabName === tabs[0].name){
                history.goBack();
              }else{
                handlePreviousFormButton()
              }
            }}
            className="insuranace-form-previous-button"
            // disabled={activeTabName === tabs[0].name}
          >
            Previous
          </button>
          {activeTabName === tabs[tabs.length - 1].name ? (
            <button
              onClick={handleSubmit}
              className="insuranace-form-Submit-button"
              style={{
                opacity: submitting
                  ? 0.5
                  : module === "Medicare V2"
                    ? (
                        submitBody &&
                        submitBody.hasOwnProperty("Policy Start Date") &&
                        submitBody.hasOwnProperty("Policy End Date") &&
                        (submitBody.hasOwnProperty("Annual or Monthly") ||
                          submitBody.hasOwnProperty("Annual / Monthly / One-Time")) &&
                        (
                          !submitBody.hasOwnProperty("Medicare Type") ||
                          (
                            submitBody["Medicare Type"] === "Medicare Advantage" &&
                            submitBody.hasOwnProperty("Part B (Medical Insurance) Premium") &&
                            submitBody["Part B (Medical Insurance) Premium"] != null &&
                            submitBody["Part B (Medical Insurance) Premium"] !== "" &&

                            submitBody.hasOwnProperty("Part C (Medicare Advantage) Monthly Premium") &&
                            submitBody["Part C (Medicare Advantage) Monthly Premium"] != null &&
                            submitBody["Part C (Medicare Advantage) Monthly Premium"] !== "" 

                            
                          ) ||
                          (
                            submitBody["Medicare Type"] === "Original Medicare" &&
                            submitBody.hasOwnProperty("Part B (Medical Insurance) Premium") &&
                            submitBody["Part B (Medical Insurance) Premium"] != null &&
                            submitBody["Part B (Medical Insurance) Premium"] !== "" &&

                            submitBody.hasOwnProperty("Part D (Prescription Drug Plan) Monthly Premium") &&
                            submitBody["Part D (Prescription Drug Plan) Monthly Premium"] != null &&
                            submitBody["Part D (Prescription Drug Plan) Monthly Premium"] !== "" &&

                            submitBody.hasOwnProperty("Medigap Supplement Plan Monthly Premium") &&
                            submitBody["Medigap Supplement Plan Monthly Premium"] != null &&
                            submitBody["Medigap Supplement Plan Monthly Premium"] !== ""
                          )
                        )
                      )
                      ? 1
                      : 0.5
                    : module === "Umbrella V2"
                      ? (
                          submitBody &&
                          submitBody.hasOwnProperty("Policy Start Date") &&
                          submitBody.hasOwnProperty("Policy End Date") &&
                          (submitBody.hasOwnProperty("Annual or Monthly") ||
                            submitBody.hasOwnProperty("Annual / Monthly / One-Time"))
                        )
                        ? 1
                        : 0.5
                      : (
                          (submitBody &&
                            submitBody.hasOwnProperty("Premium") &&
                            (submitBody.hasOwnProperty("Annual or Monthly") ||
                              submitBody.hasOwnProperty("Annual / Monthly / One-Time")) &&
                            submitBody.hasOwnProperty("Policy Start Date") &&
                            submitBody.hasOwnProperty("Policy End Date")) ||
                          (fieldsData &&
                            fieldsData.hasOwnProperty("Premium") &&
                            (fieldsData.hasOwnProperty("Annual or Monthly") ||
                              fieldsData.hasOwnProperty("Annual / Monthly / One-Time")) &&
                            fieldsData.hasOwnProperty("Policy Start Date") &&
                            fieldsData.hasOwnProperty("Policy End Date"))
                        )
                        ? 1
                        : 0.5
              }}

              disabled={
                submitting || // prevent double click
                (
                  module === "Medicare V2"
                    ? !(
                        submitBody &&
                        submitBody.hasOwnProperty("Policy Start Date") &&
                        submitBody["Policy Start Date"] != null &&
                        submitBody["Policy Start Date"] !== "" &&

                        submitBody.hasOwnProperty("Policy End Date") &&
                        submitBody["Policy End Date"] != null &&
                        submitBody["Policy End Date"] !== "" &&

                        (submitBody.hasOwnProperty("Annual or Monthly") ||
                        submitBody.hasOwnProperty("Annual / Monthly / One-Time")) &&

                        (
                          !submitBody.hasOwnProperty("Medicare Type") ||
                          (
                            submitBody["Medicare Type"] === "Medicare Advantage" &&
                            submitBody.hasOwnProperty("Part B (Medical Insurance) Premium") &&
                            submitBody["Part B (Medical Insurance) Premium"] != null &&
                            submitBody["Part B (Medical Insurance) Premium"] !== "" &&

                            submitBody.hasOwnProperty("Part C (Medicare Advantage) Monthly Premium") &&
                            submitBody["Part C (Medicare Advantage) Monthly Premium"] != null &&
                            submitBody["Part C (Medicare Advantage) Monthly Premium"] !== "" 
                            
                          ) ||
                          (
                            submitBody["Medicare Type"] === "Original Medicare" &&
                            submitBody.hasOwnProperty("Part B (Medical Insurance) Premium") &&
                            submitBody["Part B (Medical Insurance) Premium"] != null &&
                            submitBody["Part B (Medical Insurance) Premium"] !== "" &&

                            submitBody.hasOwnProperty("Part D (Prescription Drug Plan) Monthly Premium") &&
                            submitBody["Part D (Prescription Drug Plan) Monthly Premium"] != null &&
                            submitBody["Part D (Prescription Drug Plan) Monthly Premium"] !== "" &&

                            submitBody.hasOwnProperty("Medigap Supplement Plan Monthly Premium") &&
                            submitBody["Medigap Supplement Plan Monthly Premium"] != null &&
                            submitBody["Medigap Supplement Plan Monthly Premium"] !== ""
                          )
                        )
                      )

                  : module === "Umbrella V2"
                    ? !(
                        submitBody &&
                        submitBody.hasOwnProperty("Policy Start Date") &&
                        submitBody["Policy Start Date"] != null &&
                        submitBody["Policy Start Date"] !== "" &&

                        submitBody.hasOwnProperty("Policy End Date") &&
                        submitBody["Policy End Date"] != null &&
                        submitBody["Policy End Date"] !== "" &&

                        (submitBody.hasOwnProperty("Annual or Monthly") ||
                        submitBody.hasOwnProperty("Annual / Monthly / One-Time"))
                      )

                  : !(
                      submitBody &&
                      submitBody.hasOwnProperty("Premium") &&
                      submitBody["Premium"] != null &&
                      submitBody["Premium"] !== "" &&

                      (submitBody.hasOwnProperty("Annual or Monthly") ||
                      submitBody.hasOwnProperty("Annual / Monthly / One-Time")) &&

                      submitBody.hasOwnProperty("Policy Start Date") &&
                      submitBody["Policy Start Date"] != null &&
                      submitBody["Policy Start Date"] !== "" &&

                      submitBody.hasOwnProperty("Policy End Date") &&
                      submitBody["Policy End Date"] != null &&
                      submitBody["Policy End Date"] !== ""
                    )
                )
              }

            >
              Submit
            </button>
          ) : (
            <button
              onClick={handleNextFormButton}
              className="insuranace-form-Submit-button"
              style={{
                opacity: (submitBody &&
                  ( submitBody.hasOwnProperty("Policy Start Date") && submitBody.hasOwnProperty("Policy End Date"))) || 
                  (fieldsData &&
                    ( fieldsData.hasOwnProperty("Policy Start Date") && fieldsData.hasOwnProperty("Policy End Date")))
                    ? 1
                    : 0.5,
              }}
              disabled={
                !(submitBody &&
                 ( submitBody.hasOwnProperty("Policy Start Date") && submitBody.hasOwnProperty("Policy End Date")))
              }
            >
              Next
            </button>
          )}
        </div>
      )}
      <NewLoader isLoading={loading} />
    </div>
    : <InsuranceFormSkeleton/>
  );
};

const TabNavigationComponent = ({
  tabs,
  activeTabIndex,
  setActiveTabIndex,
  activeTabName,
  setActiveTabName,
  currentTab,
  AllTabs,
}) => {
  return (
    <div className="tab-navigation">
      <Styles.TabContainer>
        <div
          style={{
            width: "1400px",
            display: "flex",
            margin: "0 2rem",
            justifyContent: "center",
          }}
        >
          {AllTabs &&
            Object.keys(AllTabs).map((tabName, tabIndex) => {
              return (
                <React.Fragment key={tabIndex}>
                  {tabIndex > 0 && (
                    <Styles.SpacerLine
                      activeIndex={activeTabIndex}
                      currentIndex={tabIndex}
                    ></Styles.SpacerLine>
                  )}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      width: "70px",
                    }}
                  >
                    <Styles.TabBox
                      onClick={() => {
                        if (AllTabs[tabName].enabled) {
                          currentTab(AllTabs[tabName].name);
                          setActiveTabName(AllTabs[tabName].name);
                          setActiveTabIndex(tabIndex);
                        }
                      }}
                      activeIndex={activeTabIndex}
                      currentIndex={tabIndex}
                      isActive={AllTabs[tabName].name == activeTabName}
                      isEnabled={AllTabs[tabName].enabled}
                    >
                      <Styles.TabBoxNumber>
                        {AllTabs[tabName].priority}
                      </Styles.TabBoxNumber>
                    </Styles.TabBox>
                    <p style={{ margin: "10px 0", textAlign: "center" }}>
                      {AllTabs[tabName].name}
                    </p>
                  </div>
                </React.Fragment>
              );
            })}
        </div>
      </Styles.TabContainer>
    </div>
  );
};
export default InsuranceAllocationSubform;
